 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTHALFTITLE from '@/components/Text/halftitle'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTACK from '@/components/Text/ack'
 import TEXTINTRO from '@/components/Text/intro'
 import TEXTCHA1 from '@/components/Text/cha1'
 import TEXTCHA2 from '@/components/Text/cha2'
 import TEXTCHA3 from '@/components/Text/cha3'
 import TEXTCHA4 from '@/components/Text/cha4'
 import TEXTCHA5 from '@/components/Text/cha5'
 import TEXTCHA6 from '@/components/Text/cha6'
 import TEXTCON1 from '@/components/Text/con1'
 import TEXTGLO from '@/components/Text/glo'
 import TEXTDIA from '@/components/Text/dia'
 import TEXTABT from '@/components/Text/abt'
 import TEXTEND from '@/components/Text/end'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/ack",
 			"name" : "Text/ack",
 			"component" : TEXTACK
 		},
 		{
 			"path" : "/Text/intro",
 			"name" : "Text/intro",
 			"component" : TEXTINTRO
 		},
 		{
 			"path" : "/Text/cha1",
 			"name" : "Text/cha1",
 			"component" : TEXTCHA1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js